/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Apikeymanager_Title2Inputs */

const id_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manajemen Kunci API`)
};

const ms_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengurusan Kunci API`)
};

const da_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Nøgleadministration`)
};

const de_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Schlüssel-Verwaltung`)
};

const en_us2_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key Management`)
};

const es_es2_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administración de clave de API`)
};

const es_mx2_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administración de API Key`)
};

const fil_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pamamahala ng API Key`)
};

const fr_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestion de la clé API`)
};

const it_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestione chiave API`)
};

const hu_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API kulcs kezelés`)
};

const nl_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-sleutelbeheer`)
};

const no_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-nøkkeladministrasjon`)
};

const pl_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarządzanie kluczem API`)
};

const pt_br2_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key Management`)
};

const pt_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestão da Chave de API`)
};

const ro_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionare cheie API`)
};

const fi_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-avaimen hallinta`)
};

const sv_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-nyckelhantering`)
};

const vi_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quản lý khóa API`)
};

const tr_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Anahtar Yönetimi`)
};

const cs_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Správa API klíče`)
};

const bg_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление на API ключ`)
};

const ru_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление API-ключом`)
};

const uk_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Керування API-ключем`)
};

const ar_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إدارة مفتاح API`)
};

const hi_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API कुंजी प्रबंधन`)
};

const th_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การจัดการคีย์ API`)
};

const ja_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API キー管理`)
};

const zh_cn2_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key Management`)
};

const zh_hant1_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key Management`)
};

const ko_components_apikeymanager_title2 = /** @type {(inputs: Components_Apikeymanager_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key Management`)
};

/**
* | output |
* | --- |
* | "API Key Management" |
*
* @param {Components_Apikeymanager_Title2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_apikeymanager_title2 = /** @type {((inputs?: Components_Apikeymanager_Title2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Apikeymanager_Title2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_apikeymanager_title2(inputs)
	if (locale === "ms") return ms_components_apikeymanager_title2(inputs)
	if (locale === "da") return da_components_apikeymanager_title2(inputs)
	if (locale === "de") return de_components_apikeymanager_title2(inputs)
	if (locale === "en-US") return en_us2_components_apikeymanager_title2(inputs)
	if (locale === "es-ES") return es_es2_components_apikeymanager_title2(inputs)
	if (locale === "es-MX") return es_mx2_components_apikeymanager_title2(inputs)
	if (locale === "fil") return fil_components_apikeymanager_title2(inputs)
	if (locale === "fr") return fr_components_apikeymanager_title2(inputs)
	if (locale === "it") return it_components_apikeymanager_title2(inputs)
	if (locale === "hu") return hu_components_apikeymanager_title2(inputs)
	if (locale === "nl") return nl_components_apikeymanager_title2(inputs)
	if (locale === "no") return no_components_apikeymanager_title2(inputs)
	if (locale === "pl") return pl_components_apikeymanager_title2(inputs)
	if (locale === "pt-BR") return pt_br2_components_apikeymanager_title2(inputs)
	if (locale === "pt") return pt_components_apikeymanager_title2(inputs)
	if (locale === "ro") return ro_components_apikeymanager_title2(inputs)
	if (locale === "fi") return fi_components_apikeymanager_title2(inputs)
	if (locale === "sv") return sv_components_apikeymanager_title2(inputs)
	if (locale === "vi") return vi_components_apikeymanager_title2(inputs)
	if (locale === "tr") return tr_components_apikeymanager_title2(inputs)
	if (locale === "cs") return cs_components_apikeymanager_title2(inputs)
	if (locale === "bg") return bg_components_apikeymanager_title2(inputs)
	if (locale === "ru") return ru_components_apikeymanager_title2(inputs)
	if (locale === "uk") return uk_components_apikeymanager_title2(inputs)
	if (locale === "ar") return ar_components_apikeymanager_title2(inputs)
	if (locale === "hi") return hi_components_apikeymanager_title2(inputs)
	if (locale === "th") return th_components_apikeymanager_title2(inputs)
	if (locale === "ja") return ja_components_apikeymanager_title2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_apikeymanager_title2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_apikeymanager_title2(inputs)
	return ko_components_apikeymanager_title2(inputs)
});
export { components_apikeymanager_title2 as "components.apiKeyManager.title" }